const { sha256 } = require('js-sha256');

function hashSHA256(message) {
    if (!message) {
        return undefined;
    }

    const result = new Uint8Array(sha256.arrayBuffer(message));
    return btoa(String.fromCharCode.apply(null, result));
}

module.exports = {
    hashSHA256
};
